// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { ScrollBar } from "/utils/ScrollBarFactory";
import { use } from "react";
import state from "/redux/state";
import { useAnimation } from "/context/AnimationProvider";

const videos = [
  {
    title: "PARTICIPATE IN THE TOURNAMENT",
    videoId: "IXpjg5FX6DE",
    url: "https://www.youtube.com/embed/IXpjg5FX6DE?si=jAdY4e4-ihGd8zS7",
  },
  {
    title: "DEPOSIT $TICO",
    videoId: "Ydj4f3g4Xfs",
    url: "https://www.youtube.com/embed/Ydj4f3g4Xfs?si=l6oUAAtIiGrbhw17",
  },
  {
    title: "BUY BUNDLES",
    videoId: "b6wqs4-RAp4",
    url: "https://www.youtube.com/embed/b6wqs4-RAp4?si=Y9uZUxP4_cnItt16",
  },
];

export default function FAQ({ faqList, isEnded }) {
  const [activeTab, setActiveTab] = useState("faq");
  const contentRef = useRef(null);

  const tabs = [{ title: "FAQ", key: "faq" }];

  return (
    <section className="faq">
      <div className="wrapper df fd-c ai-c pd-lr-md">
        <div className="wrapper-tabs df ai-c">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`tab  kanit-black ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.title}
            </button>
          ))}
        </div>
        <div className="wrapper-content w-full" ref={contentRef}>
          <List faqList={faqList} isActive={true} />
          {/* {!isEnded && <Video isActive={activeTab === tabs[1].key} />} */}
        </div>
      </div>
    </section>
  );
}

function List({ faqList, isActive }) {
  const [opened, setOpened] = useState([0]);
  const scrollerRef = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    const block = scrollerRef.current;
    if (!block) return;
    let scroll = null;
    setTimeout(() => {
      scroll = ScrollBar.create({ scroller: block, draggable: false });
      barRef.current = scroll;
    }, 1000);
    return () => {
      scroll?.kill();
      barRef.current = null;
    };
  }, []);

  const handleToggle = (index) => {
    setTimeout(() => {
      barRef.current?._init();
    }, 350);
    setOpened((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  return (
    <>
      <div
        className={`scroller-wrapper w-full df fd-c ${isActive ? "active" : ""}`}
        data-prevent-observer
      >
        <div className="scroller w-full df fd-c" ref={scrollerRef}>
          <div className="list df fd-c">
            {faqList.length &&
              faqList.map((item, index) => (
                <div
                  className={`item ${opened.includes(index) ? "opened" : ""}`}
                  key={index}
                >
                  <button
                    className="question fixel_22"
                    onClick={() => handleToggle(index)}
                  >
                    {item.question}
                    <div className="icon mask_arrow"></div>
                  </button>
                  <div className={`item-collapse`}>
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    ></div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}
// function Video({ isActive }) {
//   const [activeVideo, setActiveVideo] = useState(null);
//   const { isMobile } = useAnimation();

//   useEffect(() => {
//     activeVideo &&
//       !isMobile &&
//       state.setPopUp("data", {
//         custom: () => (
//           <div className="video-popup">
//             <iframe
//               src={activeVideo.url}
//               title={activeVideo.title}
//               frameBorder="0"
//               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//               referrerPolicy="strict-origin-when-cross-origin"
//               allowFullScreen
//             ></iframe>
//           </div>
//         ),
//         onClose: () => setActiveVideo(null),
//       });
//     return () => {};
//   }, [activeVideo]);

//   return (
//     <>
//       <div className={`videos-wrapper ${isActive ? "active" : ""}`}>
//         {videos.map((video) => (
//           <div
//             key={video.videoId}
//             className="video"
//             onClick={() => setActiveVideo(video)}
//           >
//             <div className="icon df">
//               {isMobile && activeVideo?.videoId == video.videoId ? null : (
//                 <div className="icon_play"></div>
//               )}
//               {isMobile && activeVideo?.videoId == video.videoId ? (
//                 <iframe
//                   src={activeVideo.url}
//                   title={activeVideo.title}
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                   referrerPolicy="strict-origin-when-cross-origin"
//                   allowFullScreen
//                 ></iframe>
//               ) : (
//                 <img
//                   src={`https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`}
//                   alt={video.title}
//                 />
//               )}
//             </div>
//             <p className="fixel_16_bl">{video.title}</p>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// }
